(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itwaar-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('itwaar-announcement')) {
    customElements.define('itwaar-announcement', class extends HTMLElement {
      connectedCallback() {
        this.group = this.querySelector('.itwaar-announcement__group');
        this.track = this.querySelector('.itwaar-announcement__track');
        this.viewport = this.querySelector('.itwaar-announcement__viewport');
        this.message = this.group.querySelector('.itwaar-announcement__message');
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.refresh = () => this.buildTrack();
        this.motionPreference.addEventListener('change', this.refresh);
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this.viewport);
        this.buildTrack();
        document.fonts.ready.then(() => { if (this.isConnected) this.buildTrack(); });
      }
      buildTrack() {
        /* Always retain one accessible original; repeated copies are decorative. */
        this.track.querySelectorAll('[data-repeat]').forEach(copy => copy.remove());
        const animate = this.dataset.animate === 'true' && !this.motionPreference.matches;
        this.dataset.running = animate ? 'true' : 'false';
        if (!animate) return;
        const viewportWidth = this.viewport.getBoundingClientRect().width;
        const messageWidth = this.message.getBoundingClientRect().width;
        if (!viewportWidth || !messageWidth) return;
        const count = Math.max(1, Math.ceil(viewportWidth / messageWidth));
        for (let i = 1; i < count; i++) {
          const copy = this.message.cloneNode(true);
          copy.dataset.repeat = '';
          copy.setAttribute('aria-hidden', 'true');
          this.group.appendChild(copy);
        }
        /* Duplicate the whole group: its exact width is the seamless loop distance. */
        const distance = this.group.getBoundingClientRect().width;
        const secondGroup = this.group.cloneNode(true);
        secondGroup.dataset.repeat = '';
        secondGroup.setAttribute('aria-hidden', 'true');
        this.track.appendChild(secondGroup);
        this.style.setProperty('--itwaar-distance', distance + 'px');
        /* Reference video moves left at approximately 53 CSS pixels per second. */
        this.style.setProperty('--itwaar-duration', (distance / 53) + 's');
      }
      disconnectedCallback() {
        this.resizeObserver.disconnect();
        this.motionPreference.removeEventListener('change', this.refresh);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itwaar-faq"]) return;
  try {
    
document.addEventListener('toggle', function(event) {
  var item = event.target;
  if (!(item instanceof HTMLDetailsElement) || !item.classList.contains('ib-faq__item') || !item.open) return;
  var group = item.closest('.ib-faq');
  if (!group || group.dataset.singleOpen !== 'true') return;
  group.querySelectorAll('.ib-faq__item[open]').forEach(function(other) { if (other !== item) other.open = false; });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-facebook-message"] && !Shopify.designMode) return;
  try {
    
	jQuery(document).ready(function($) {
		$(document).on('click', '.ss-fb-ms-bottom', function() {
			$('.ss-fb-ms-inner').show();
			$(this).hide();
		})

		$(document).on('click', '.offline_heading', function() {
			$('.ss-fb-ms-inner').hide();
			$('.ss-fb-ms-bottom').show();
		})
	})

  } catch(e) { console.error(e); }
})();
})();
